<template>
  <div>
    <PlanComponentVue mode="create" />
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { setHeader, removeHeader } from "@/http";
import { AtomSpinner } from "epic-spinners";
import { VueEditor } from "vue2-editor";
import TreeNode from "@/components/treeView.vue";
import PlanComponentVue from "./PlanComponent.vue";
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const planEmptyObj = {
  planType: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy HH:mm:ss",
  endDate: "",
  serviceId: "",
  isAdvance: false,
  isPrepaid: false,
  billRule: "",
  currencyId: "",
  externalPlanId: "",
  externalPlanName: "",
  durations: "",
  planCode: "",
  billfrequency: "",
  planDescription: "",
  units: 0,
  volume: "None",
  provisioingSystem: "None",
  startDate: moment().format("DD MMMM yyyy HH:mm:ss"),
};
export default {
  components: {
    FormWizard,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    "v-select": vSelect,
    Multiselect,
    AtomSpinner,
    VueEditor,
    PlanComponentVue,
    TreeNode,
  },
  data() {
    return {
      status: "DRAFT",
      version: 1,
      selectedStatusId: 0,
      selectedRuleType: "",
      plansByRule: {},
      selectedSourcePlan: null,
      selectedTargetPlan: null,
      errorMessage: "",
      warningPopup: false,
      warningText: "",
      name: "",
      selectedAttribute: [],
      selectedBillFrequency: [],
      selectedDurations: [],
      enabledOptions: [true, false],
      billType: ["Advance", "Arrear"],
      id: "",
      billTypes: "",
      enabled: false,
      userChangePassword: false,
      plan: planEmptyObj,
      serviceData: "",
      serviceCode: "",
      productsShow: false,
      selected: "",
      isProvision: true,
      availableproductsX: [],
      availableproducts: [],
      availableChannels: [],
      services: [],
      selectedProducts: [],
      startDate: "",
      endDate: "",
      serviceObject: {},
      productsOfService: [],
      selectedProduct: "",
      addedProducts: [],
      allDiscounts: [],
      selectedDiscount: "",
      addedDiscounts: [],
      bulkUploads: {
        file: null,
      },
      selectedExternalProductId: "",
      planAttributes: [],
      //price
      editPriceArray: [],
      chargeOwners: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      chargeCodeOptions: null,
      durationOptions: null,
      prepaid: false,
      currencyCode: "",
      roundingTypes: ["RoundingUp", "RoundingDown", "RoundingHalf", "RoundingNearest"],
      productTypeId: 0,
      chargeCode: "",
      chargeOwner: "",
      chargevariant: "",
      currencyId: "",
      discountId: "",
      isPrepaid: "",
      locale: "en",
      planCode: "",
      price: "",
      sellingPrice: "",
      priceregion: "",
      productId: "",
      duration: "",
      roundingType: "",
      GLID: "",
      planPrice: "",
      isPriceUpdated: true,
      discountPopup: false,
      currentProductObj: {},
      currentProductIndex: "",
      type: "NONE",
      //content
      loading: false,
      editContentPopup: false,
      createContentPopup: false,
      viewContentPopup: false,
      deleteContentPopup: false,
      selectLanguagePopup: false,
      contentUploadPopup: false,
      editData: {
        planId: "",
        text: "",
        type: "",
        locale: "",
        docId: "",
      },
      file: "",
      content: "",
      selectedLanguage: "",
      selectedNewLanguage: "",
      selectedNewType: "",
      selectedType: null,
      treeSelectedLanguage: null,
      treeContentType: null,
      dataToDelete: null,
      customToolbar: [["link", "image", "video"]],
      selectedContentTagValue: "",
      selectedContentTag: "",
    };
  },
  // computed: {
  //   ...mapState({
  //     termsAndConditions: (state) => state.planPrice.termsAndConditions,
  //     LanguageList: (state) => state.planPrice.localeLanguage,
  //     typeOptions: (state) => state.planPrice.contentType,
  //     contentTagList: (state) => state.planPrice.contentTagData,
  //     contentTagValueList: (state) => state.planPrice.contentTagValueData,
  //     planTemplateData: (store) => store.planPrice.planTemplateData,
  //     planAttributeDatas: (store) => store.planPrice.planAttribute,
  //     planAttributeValueDatas: (store) => store.planPrice.planAttributeValue,
  //     priceWithTemplate: (store) => store.planPrice.priceWithTemplate,
  //     discountTemplate: (store) => store.planPrice.discountTemplate,
  //     ExternalPlansList: (store) => store.planPrice.externalPlans,
  //     getBillingFrequency: (store) => store.chargecode.list,
  //     productDiscounts: (state) => state.planPrice.productDiscounts,
  //     planWithTempate: (state) => state.planPrice.planWithTempate,
  //     validationRuleTemplate: (state) => state.planValidationRules.validationRuleTemplate,
  //   }),

  //   selectedStatus() {
  //     if (this.planTemplateData && this.planTemplateData.planStatus) {
  //       const statusObj = this.planTemplateData.planStatus.find(
  //         (item) => item.id === this.selectedStatusId
  //       );
  //       return statusObj ? statusObj.value : "N/A";
  //     }
  //   },
  //   filteredTypeOptions() {
  //     if (!Array.isArray(this.termsAndConditions)) {
  //       return this.typeOptions;
  //     }
  //     return this.typeOptions.filter(
  //       (type) => !this.termsAndConditions.some((term) => term.type === type.mCodeValue)
  //     );
  //   },
  //   productOptions() {
  //     if (this.ExternalPlansList) {
  //       const id =
  //         this.plan && this.plan.externalPlanId && this.plan.externalPlanId.pkg_id
  //           ? this.plan.externalPlanId.pkg_id
  //           : "";
  //       const selectedPlan = this.ExternalPlansList.find((plan) => plan.pkg_id === id);
  //       return selectedPlan ? selectedPlan.productList : [];
  //     } else return [];
  //   },
  //   currencyOptions() {
  //     if (this.planTemplateData && this.planTemplateData.currencydata) {
  //       return this.planTemplateData.currencydata.currencyOptions.map((el) => {
  //         return {
  //           ...el,
  //           labelStr: `${el.code}--${el.name}`,
  //         };
  //       });
  //     } else {
  //       return [];
  //     }
  //   },
  //   selectedDiscountId() {
  //     let arr = [];
  //     if (this.addedDiscounts && this.addedDiscounts.length) {
  //       this.addedDiscounts.forEach((el) => arr.push(el.discountId));
  //     }
  //     return arr;
  //   },
  //   //price
  //   allCurrencies() {
  //     const seen = new Set();
  //     return this.resourceOptions.filter((item) => {
  //       if (seen.has(item.id)) {
  //         return false;
  //       } else {
  //         seen.add(item.id);
  //         return true;
  //       }
  //     });
  //   },
  //   resourceOptions() {
  //     if (this.priceWithTemplate && this.priceWithTemplate.currencydata) {
  //       return [
  //         ...this.priceWithTemplate.currencydata.selectedCurrencyOptions,
  //         ...this.priceWithTemplate.currencydata.currencyOptions,
  //         ...this.priceWithTemplate.currencydata.noncurrencyOptions,
  //       ];
  //     } else return [];
  //   },
  //   productPriceList() {
  //     let arr = [];
  //     if (this.type != "NONE") {
  //       this.editPriceArray.map((el) => {
  //         if (el.productCode == this.type) {
  //           arr.push(el);
  //         }
  //       });
  //     } else {
  //       arr = [...this.editPriceArray];
  //     }
  //     return arr;
  //   },
  // },
  // methods: {
  //   setAttributes(fieldName, value) {
  //     const existingAttribute = this.planAttributes.find(
  //       (attr) => attr.attributeName === fieldName
  //     );
  //     if (existingAttribute) {
  //       existingAttribute.attributeValue = value.mCodeValue;
  //     } else {
  //       this.planAttributes.push({
  //         attributeName: fieldName,
  //         attributeValue: value.mCodeValue,
  //       });
  //     }
  //   },
  //   dateFormat(val) {
  //     let month = monthNames[val.getMonth()];
  //     return (
  //       val.getDate() +
  //       " " +
  //       month +
  //       " " +
  //       val.getFullYear() +
  //       " " +
  //       val.getHours() +
  //       ":" +
  //       val.getMinutes() +
  //       ":" +
  //       val.getSeconds()
  //     );
  //   },
  //   async changeFile(file) {
  //     this.bulkUploads.file = file;
  //   },
  //   async getPlanTemplate() {
  //     try {
  //       await this.$store.dispatch("planPrice/setPlanTemplateData");
  //     } catch (e) {
  //       this.$toasted.error(e.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async getPlanAttribute() {
  //     try {
  //       await this.$store.dispatch("planPrice/setPlanAttributes");
  //     } catch (e) {
  //       this.$toasted.error(e.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async getPlanAttributeValue() {
  //     try {
  //       await this.$store.dispatch("planPrice/setPlanAttributesValue");
  //     } catch (e) {
  //       this.$toasted.error(e.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async callPriceTemplate() {
  //     try {
  //       await this.$store.dispatch("chargecode/setEntities");
  //     } catch (e) {
  //       this.$toasted.error(e.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async createplan() {
  //     console.log("Helloooo");
  //     const isValid = await this.$refs.observer.validate();
  //     if (!isValid) return;
  //     if (this.addedProducts.length == 0) {
  //       this.warningPopup = true;
  //       this.warningText = "Please add atleast one product";
  //       return;
  //     }
  //     this.plan.startDate = moment(this.plan.startDate).format("DD MMMM yyyy HH:mm:ss");
  //     this.plan.endDate = moment(this.plan.endDate).format("DD MMMM yyyy HH:mm:ss");
  //     for (let temp of this.services) {
  //       if (temp.serviceCode == this.serviceCode) {
  //         this.plan.serviceId = temp.id;
  //       }
  //     }
  //     this.plan.productList = this.addedProducts.map((product) => ({
  //       productId: product.product.id,
  //       extProductId: product.externalId.produc_tid || null,
  //       externalProductName: product.externalId.product_name || null,
  //     }));
  //     this.plan.provisioingSystem = this.isProvision ? "Provision" : "None";
  //     if (this.plan.externalPlanId) {
  //       this.plan.externalPlanName = this.plan.externalPlanId.pkg_name;
  //       this.plan.externalPlanId = this.plan.externalPlanId.pkg_id;
  //     }
  //     this.plan.isAdvance = this.billTypes == "Advance" ? true : false;
  //     const payload = {
  //       ...this.plan,
  //       status: this.selectedStatusId,
  //       version: this.version,
  //       isBaseOverride: false,
  //       planAttributes: this.planAttributes,
  //       planDiscounts: this.selectedDiscountId,
  //       dateFormat: "dd MMMM yyyy HH:mm:ss",
  //       locale: "en",
  //     };
  //     try {
  //       const resp = await this.$store.dispatch("planPrice/createPlanAction", payload);
  //       if (this.bulkUploads.file) {
  //         let formData = new FormData();
  //         setHeader("Content-Type", "multipart/form-data");
  //         formData.append("name", "attachment");
  //         formData.append("file", this.bulkUploads.file);
  //         removeHeader("Content-Type");
  //         await this.$store.dispatch("planPrice/uploadAttachmentAction", {
  //           id: resp.data.resourceId,
  //           data: formData,
  //         });
  //       }
  //       await this.$swal({
  //         title: "Success",
  //         icon: "success",
  //         text: "Plan Created Successfully!",
  //         type: "success",
  //       });
  //       this.$refs.wizard.nextTab();
  //       this.id = resp.data.resourceId;
  //       await this.getPlanDetailsByIdPlan(this.id);
  //       this.getProductDiscountTemplate();
  //       await this.getPriceWithTemplate(this.id);
  //       const billFrequencyValues = this.planWithTempate.billfrequencyValues.map(Number); // Ensure they are numbers
  //       const chargeData = this.priceWithTemplate.chargeData;

  //       // Filter matching items
  //       const commonBillData = chargeData.filter((item) =>
  //         billFrequencyValues.includes(item.id)
  //       );

  //       const durationValues = this.planWithTempate.durationsValues.map(Number); // Ensure they are numbers
  //       const contractPeriods = this.priceWithTemplate.contractPeriods;

  //       // Filter matching items
  //       const commonDurationData = contractPeriods.filter((item) =>
  //         durationValues.includes(item.id)
  //       );

  //       this.chargeCodeOptions = commonBillData;
  //       this.durationOptions = commonDurationData;

  //       // this.currencyId = 1;
  //       this.resetForm();
  //     } catch (e) {
  //       this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
  //         "The parameter",
  //         ""
  //       );
  //       this.warningPopup = true;
  //       this.errors = e.message.errors;
  //     }
  //   },
  //   onSelectService(val) {
  //     this.serviceObject = {};
  //     this.productsOfService = this.planTemplateData.products.filter(
  //       (el) => el.serviceId == val.id
  //     );
  //     this.addedProducts = [];
  //     this.serviceObject = {
  //       ...val,
  //       products: [...this.productsOfService],
  //     };
  //   },
  //   onChangeProduct() {
  //     let filter = {};
  //     this.addedProducts.forEach((el) => (filter[el.id] = true));
  //     let restProducts = this.productsOfService.filter((el) => !filter[el.id]);
  //     this.serviceObject = {
  //       ...this.serviceObject,
  //       products: [...restProducts],
  //     };
  //   },
  //   addProduct() {
  //     if (!this.addedProducts.some((el) => el.id == this.selectedProduct.id)) {
  //       this.addedProducts.push({
  //         product: this.selectedProduct,
  //         externalId: this.selectedExternalProductId,
  //       });
  //     }
  //     let filter = {};
  //     this.addedProducts.forEach((el) => (filter[el.product.id] = true));
  //     let restProducts = this.serviceObject.products.filter((el) => !filter[el.id]);
  //     this.serviceObject = {
  //       ...this.serviceObject,
  //       products: [...restProducts],
  //     };
  //     this.selectedProduct = "";
  //     this.selectedExternalProductId = "";
  //   },
  //   removeProduct(product, ind) {
  //     this.addedProducts.splice(ind, 1);
  //     this.serviceObject.products.push(product);
  //   },
  //   onChangeDiscount() {
  //     let filter = {};
  //     this.addedDiscounts.forEach((el) => (filter[el.discountId] = true));
  //     let resDiscounts = this.discountTemplate.filter((el) => !filter[el.discountId]);
  //     this.allDiscounts = resDiscounts.map((el) => {
  //       return { ...el };
  //     });
  //   },
  //   removeDiscount(dis) {
  //     this.addedDiscounts = this.addedDiscounts.filter(
  //       (el) => el.discountId != dis.discountId
  //     );
  //     this.allDiscounts.push(dis);
  //   },
  //   async getDiscountTemplate() {
  //     try {
  //       await this.$store.dispatch("planPrice/fetchDiscountTemplate");
  //     } catch (e) {
  //       this.$toasted.error(e.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async getExternalPlansMethod() {
  //     try {
  //       await this.$store.dispatch("planPrice/getExternalPlansAction");
  //     } catch (e) {
  //       this.$swal({
  //         title: "Error",
  //         icon: "error",
  //         text: "Unable To Fetch Enternal Plans!",
  //         type: "error",
  //       });
  //     }
  //   },
  //   resetForm() {
  //     this.plan = {
  //       isPrepaid: false,
  //       isAdvance: false,
  //       durations: null,
  //       planCode: "",
  //       billfrequency: "",
  //       planDescription: "",
  //       planType: null,
  //       startDate: moment().format("DD MMMM yyyy HH:mm:ss"),
  //       endDate: null,
  //       billRule: null,
  //       currencyId: null,
  //     };
  //     this.serviceData = null;
  //     this.selectedProduct = null;
  //     this.addedProducts = [];
  //     this.serviceObject = {};
  //     this.isProvision = true;
  //     // Reset file upload
  //     // this.$refs.fileUploadComponent.bulkUploads.file = null;
  //     // this.$refs.fileUploadComponent.fileStatus = "No File Selected";
  //     // const fileInput =
  //     //   this.$refs.fileUploadComponent.$el.querySelector("input[type='file']");
  //     // if (fileInput) {
  //     //   fileInput.value = null;
  //     // }
  //     this.$refs.observer.reset();
  //   },
  //   cancel() {
  //     this.$router.push("/setup/plan-pricing");
  //   },
  //   //price
  //   async addData() {
  //     if (this.type) {
  //       let product = this.priceWithTemplate.serviceData.find(
  //         (el) => el.productCode == this.type
  //       );
  //       if (product) this.productTypeId = product.id;
  //     }
  //     let Payload1 = {
  //       id: this.id,
  //       planCode: this.priceWithTemplate.planCode,
  //       price: this.planPrice,
  //       // sellingPrice: this.sellingPrice,
  //       chargeCode: this.chargeCode,
  //       duration: this.duration,
  //       isPrepaid: this.priceWithTemplate.isPrepaid === "N" ? false : true,
  //       currencyId: this.currencyId,
  //       productId: this.productTypeId,
  //       glId: this.GLID,
  //       productCode: this.type,
  //       discountId: this.selectedDiscount || 1,
  //       chargeOwner: this.chargeOwner,
  //       type: "c",
  //       chargevariant: this.priceWithTemplate.chargevariant[0].id,
  //       roundingType: this.roundingType,
  //       locale: "en",
  //     };

  //     try {
  //       await this.$store.dispatch("planPrice/addPriceAction", {
  //         id: this.id,
  //         data: Payload1,
  //       });
  //       this.$swal({
  //         title: "Success",
  //         icon: "success",
  //         text: "Price added successfully!",
  //         type: "success",
  //       });
  //       this.getPriceWithTemplate(this.id);
  //       this.chargeCode = "";
  //       this.chargeOwner = "";
  //       this.chargevariant = "";
  //       this.currencyId = "";
  //       this.discountId = "";
  //       this.isPrepaid = "";
  //       this.locale = "en";
  //       this.planCode = "";
  //       this.price = "";
  //       this.sellingPrice = "";
  //       this.planPrice = "";
  //       this.priceregion = "";
  //       this.productId = "";
  //       this.duration = "";
  //       this.roundingType = "";
  //       this.GLID = "";
  //     } catch (e) {
  //       this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
  //         "The parameter",
  //         ""
  //       );
  //       this.warningPopup = true;
  //       this.errors = e.message.errors;
  //     }
  //   },
  //   async getPriceWithTemplate(planId) {
  //     try {
  //       await this.$store.dispatch("planPrice/setPriceWithTemplate", planId);
  //       this.priceWithTemplate.serviceData.push({
  //         productDescription: "NONE",
  //         id: 0,
  //       });
  //       this.editPriceArray = this.priceWithTemplate.pricingData.map((el) => {
  //         return { ...el };
  //       });
  //       this.editPriceArray.forEach((el) => {
  //         this.priceWithTemplate.priceRegionData.forEach((x) => {
  //           if (x.priceregion == el.priceregion) el.priceregion = x.id;
  //         });
  //       });

  //       this.editPriceArray.forEach((el) => {
  //         this.priceWithTemplate.chargeData.forEach((x) => {
  //           if (x.chargeDescription == el.chargeCode) el.chargeCode = x.chargeCode;
  //         });
  //       });

  //       this.editPriceArray.forEach((el) => {
  //         this.priceWithTemplate.chargevariant.forEach((x) => {
  //           if (x.value == el.chargeVariant) el.chargevariant = x.id;
  //           delete el.chargeVariant;
  //         });
  //       });
  //     } catch (e) {
  //       this.$toasted.error(e.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async getPlanDetailsByIdPlan(id) {
  //     try {
  //       await this.$store.dispatch("planPrice/getPlanById", id);
  //     } catch (error) {
  //       //
  //     }
  //   },
  //   async editPrices() {
  //     this.isPriceUpdated = true;
  //     for (let temp of this.editPriceArray) {
  //       delete temp.contractId;
  //       delete temp.billingFrequency;
  //       delete temp.currencyCode;
  //       temp.discountId = temp.discountId || 1;
  //       temp.locale = "en";
  //       try {
  //         await this.$store.dispatch("planPrice/updatePriceAction", {
  //           id: temp.id,
  //           data: temp,
  //         });
  //       } catch (e) {
  //         this.isPriceUpdated = false;
  //         this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
  //           "The parameter",
  //           ""
  //         );
  //         this.warningPopup = true;
  //         this.errors = e.message.errors;
  //         break;
  //       }
  //     }
  //     if (this.isPriceUpdated) {
  //       this.$swal({
  //         title: "Success",
  //         icon: "success",
  //         text: "Price updated successfully!",
  //         type: "success",
  //       });
  //       // this.$router.push({ path: "/setup/plan-pricing" });
  //     }
  //   },
  //   async addUpdateDiscount() {
  //     let payload = {
  //       chargeOwner: this.productPriceList[this.currentProductIndex].chargeOwner,
  //       planCode: this.productPriceList[this.currentProductIndex].planCode,
  //       isPrepaid: this.productPriceList[this.currentProductIndex].isPrepaid,
  //       productId: this.productPriceList[this.currentProductIndex].productId,
  //       discountId: this.selectedDiscount || "1",
  //       chargeCode: this.productPriceList[this.currentProductIndex].chargeCode,
  //       currencyId: this.productPriceList[this.currentProductIndex].currencyId,
  //       price: this.productPriceList[this.currentProductIndex].price.toString(),
  //       chargevariant: this.productPriceList[this.currentProductIndex].chargevariant,
  //       locale: "en",
  //       type: "D",
  //     };
  //     try {
  //       await this.$store.dispatch("planPrice/updatePriceAction", {
  //         id: this.currentProductObj.id,
  //         data: payload,
  //       });
  //       this.discountPopup = false;
  //     } catch (error) {
  //       this.$toasted.error(error.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   async deletePrice(data) {
  //     await this.$store.dispatch("planPrice/deletePriceAction", data.id);
  //     this.getPriceWithTemplate(this.id);
  //   },
  //   async getProductDiscountTemplate() {
  //     try {
  //       await this.$store.dispatch("planPrice/fetchProductDiscountTemplate");
  //     } catch (error) {
  //       this.$toasted.error(error.message, {
  //         duration: 2000,
  //       });
  //     }
  //   },
  //   //content
  //   handleLanguagePopupClose(isActive) {
  //     if (!isActive) {
  //       this.content = "";
  //       this.selectedType = null;
  //       this.selectedLanguage = null;
  //       this.selectedNewLanguage = null;
  //       this.selectedNewType = null;
  //     }
  //   },
  //   handleViewContent(data) {
  //     this.viewContentData(data.children[0]);
  //   },
  //   handleEditContent(data) {
  //     this.editContentData(data.children[0]);
  //   },
  //   async handleDeleteContent(data) {
  //     this.dataToDelete = data.children[0];
  //     this.deleteContentPopup = true;
  //   },
  //   async handleAddLanguage(data) {
  //     this.content = "";
  //     this.selectedType = "";
  //     this.selectedLanguage = "";
  //     this.selectedNewType = data.type;
  //     this.selectLanguagePopup = true;
  //   },
  //   onClickNext() {
  //     this.treeContentType = this.selectedNewType;
  //     this.treeSelectedLanguage = this.selectedNewLanguage;
  //     this.selectLanguagePopup = false;
  //     if (this.treeContentType == "Digital_Image") {
  //       this.contentUploadPopup = true;
  //     } else {
  //       this.createContentPopup = true;
  //     }
  //   },
  //   transformDataToTree(data) {
  //     const tree = [];
  //     const map = {};
  //     data.forEach((item) => {
  //       const type = item.type;
  //       if (!map[type]) {
  //         map[type] = {
  //           id: type,
  //           type: item.type,
  //           children: [],
  //         };
  //         tree.push(map[type]);
  //       }
  //       if (!map[type][item.language]) {
  //         const details = {
  //           text: item.text,
  //           planId: item.planId,
  //           type: item.type,
  //           storageTypeEnum: item.storageTypeEnum,
  //           language: item.language,
  //           documentId: item.documentId,
  //         };
  //         map[type].children.push({
  //           language: item.language,
  //           children: [details],
  //         });
  //       } else {
  //         map[type].children
  //           .find((child) => child.language === item.language)
  //           .children.push({ text: item.text });
  //       }
  //     });
  //     return tree;
  //   },
  //   async createPlanContentMethod() {
  //     try {
  //       // this.loading = true;
  //       let payload = {
  //         planId: this.id,
  //         type: "",
  //         text: this.content,
  //         locale: "",
  //       };
  //       if (this.treeSelectedLanguage && this.treeContentType) {
  //         payload.type = this.treeContentType;
  //         payload.locale = this.treeSelectedLanguage;
  //       } else {
  //         payload.type = this.selectedType.mCodeValue;
  //         payload.locale = this.selectedLanguage;
  //       }
  //       this.createContentPopup = false;
  //       this.contentUploadPopup = false;
  //       await this.$store.dispatch("planPrice/createPlanContentAction", {
  //         ...payload,
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       await this.fetchTermsConditions();
  //       this.$swal({
  //         title: "Success",
  //         icon: "success",
  //         text: "Plan Content Created Successfully!",
  //         type: "success",
  //       });
  //       this.selectedType = null;
  //       this.content = "";
  //       this.treeSelectedLanguage = null;
  //       this.treeContentType = null;
  //       this.selectedNewLanguage = null;
  //       this.selectedNewType = null;
  //       this.selectedContentTag = null;
  //       this.selectedContentTagValue = null;
  //     } catch (e) {
  //       await this.fetchTermsConditions();
  //       this.selectedType = null;
  //       this.content = "";
  //       this.treeSelectedLanguage = null;
  //       this.treeContentType = null;
  //       this.$swal({
  //         title: "Error",
  //         icon: "error",
  //         text: e.message.errors[0].defaultUserMessage,
  //         type: "error",
  //       });
  //     }
  //   },
  //   uploadOnChange(file) {
  //     this.file = file ? file : null;
  //   },
  //   async updatePlanContentMethod() {
  //     try {
  //       let payload = {
  //         planId: this.editData.planId,
  //         type: this.editData.type,
  //         text: this.editData.text,
  //         locale: this.editData.locale,
  //       };
  //       this.editContentPopup = false;
  //       await this.$store.dispatch("planPrice/editPlanContentAction", payload);
  //       await this.fetchTermsConditions();
  //       this.$swal({
  //         title: "Success",
  //         icon: "success",
  //         text: "Plan Content Updated Successfully!",
  //         type: "success",
  //       });
  //       this.selectedType = null;
  //       this.content = "";
  //     } catch (e) {
  //       this.selectedType = null;
  //       this.content = "";
  //       this.$swal({
  //         title: "Error",
  //         icon: "error",
  //         text: "Something Went Wrong!",
  //         type: "error",
  //       });
  //     }
  //   },
  //   editContentData(data) {
  //     this.editContentPopup = true;
  //     this.editData.planId = data.planId;
  //     this.editData.text = data.text;
  //     this.editData.type = data.type;
  //     this.editData.locale = data.storageTypeEnum;
  //     this.editData.docId = data.documentId;
  //   },
  //   viewContentData(data) {
  //     this.viewContentPopup = true;
  //     this.editData.text = data.text;
  //   },
  //   handlePopupClose(isActive) {
  //     if (!isActive) {
  //       this.content = "";
  //       this.selectedType = null;
  //       this.selectedLanguage = null;
  //       this.selectedNewLanguage = null;
  //       this.selectedNewType = null;
  //       this.treeSelectedLanguage = null;
  //       this.treeContentType = null;
  //     }
  //   },

  //   async deleteContentData(data) {
  //     const payload = {
  //       id: data.planId,
  //       docId: data.documentId,
  //     };
  //     this.deleteContentPopup = false;
  //     try {
  //       await this.$store.dispatch("planPrice/deleteContentAction", payload);
  //       await this.fetchTermsConditions();
  //     } catch (error) {
  //       this.$toasted.error("Something Went Wrong", {
  //         duration: 2000,
  //       });
  //     }
  //   },

  //   async fetchTermsConditions() {
  //     const SelectedLanguage = this.LanguageList.find(
  //       (lang) => lang.id === this.selectedLanguage
  //     );
  //     const data = {
  //       id: this.id,
  //       lang: "",
  //       type: "",
  //     };
  //     if (SelectedLanguage) {
  //       data.lang = SelectedLanguage.value;
  //     } else {
  //       data.lang = "en";
  //     }
  //     if (this.selectedType && this.selectedType.value) {
  //       data.type = this.selectedType.value;
  //     }
  //     try {
  //       await this.$store.dispatch("planPrice/setTermsConditions", data);
  //       this.treeData = this.transformDataToTree(this.termsAndConditions);
  //     } catch (e) {
  //       //
  //     }
  //   },
  //   async getLocaleLanguageMethod() {
  //     try {
  //       await this.$store.dispatch("planPrice/getLocaleLanguageAction");
  //     } catch (e) {
  //       //
  //     }
  //   },
  //   async getContentTagMethod() {
  //     try {
  //       await this.$store.dispatch("planPrice/getContentTagAction");
  //     } catch (e) {
  //       //
  //     }
  //   },
  //   async getContentTagValueMethod() {
  //     try {
  //       await this.$store.dispatch("planPrice/getContentTagValueAction");
  //     } catch (e) {
  //       //
  //     }
  //   },
  //   async getContentTypeMethod() {
  //     try {
  //       await this.$store.dispatch("planPrice/getContentTypeAction");
  //     } catch (e) {
  //       //
  //     }
  //   },

  //   // validation rule
  //   selectRuleType(rule) {
  //     this.selectedRuleType = rule.codeValue;
  //   },
  //   async initializePlansByRule() {
  //     // Initialize empty lists for each rule type
  //     const RulesList = this.validationRuleTemplate.ruleExpressionList;
  //     const PlansList = this.validationRuleTemplate.planList;
  //     await RulesList.forEach((rule) => {
  //       const filteredPlans = PlansList.filter(
  //         (plan) => plan.id !== this.planWithTempate.id
  //       );
  //       this.$set(this.plansByRule, rule.codeValue, {
  //         sourcePlans: [...filteredPlans], // Start with all plans in source
  //         targetPlans: [],
  //       });
  //     });
  //   },
  //   moveToTarget() {
  //     if (!this.selectedSourcePlan) return;
  //     const rulePlans = this.plansByRule[this.selectedRuleType];

  //     const planIndex = rulePlans.sourcePlans.findIndex(
  //       (p) => p.id === this.selectedSourcePlan
  //     );
  //     if (planIndex !== -1) {
  //       const [movedPlan] = rulePlans.sourcePlans.splice(planIndex, 1);
  //       rulePlans.targetPlans.push(movedPlan);
  //       this.selectedSourcePlan = null;
  //     }
  //   },
  //   moveToSource() {
  //     if (!this.selectedTargetPlan) return;
  //     const rulePlans = this.plansByRule[this.selectedRuleType];

  //     const planIndex = rulePlans.targetPlans.findIndex(
  //       (p) => p.id === this.selectedTargetPlan
  //     );
  //     if (planIndex !== -1) {
  //       const [movedPlan] = rulePlans.targetPlans.splice(planIndex, 1);
  //       rulePlans.sourcePlans.push(movedPlan);
  //       this.selectedTargetPlan = null;
  //     }
  //   },
  //   async getTemplateData() {
  //     try {
  //       await this.$store.dispatch(
  //         "planValidationRules/getPlanValidationRulesTemplateAction"
  //       );
  //     } catch (error) {
  //       throw Error(
  //         error.message.errors[0].defaultUserMessage ||
  //           `Api failed with status code: ${error.message.httpStatusCode}`
  //       );
  //     }
  //   },
  //   async createValidationRule(payload) {
  //     try {
  //       await this.$store.dispatch(
  //         "planValidationRules/createValidationRuleAction",
  //         payload
  //       );
  //       await this.$swal({
  //         title: "Success",
  //         icon: "success",
  //         text: "Validation Rule Created Successfully!",
  //         type: "success",
  //       });
  //     } catch (e) {
  //       this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
  //         "The parameter",
  //         ""
  //       );
  //       this.warningPopup = true;
  //       this.errors = e.message.errors;
  //     }
  //   },
  //   async goToValidationRule() {
  //     this.$refs.wizard.nextTab();
  //     this.loading = true;
  //     await this.getTemplateData();
  //     await this.initializePlansByRule();
  //     this.loading = false;
  //   },
  //   async lastTabSubmit() {
  //     this.$router.push(`/setup/plan-pricing`);
  //   },
  //   async goToDigitalContent() {
  //     const inputPlanId = this.id; // ID of the selected plan
  //     const ruleAppliesTo = 640; // Constant value

  //     // Construct validationRules array
  //     const validationRules = [];
  //     Object.keys(this.plansByRule).forEach((ruleKey) => {
  //       const rule = this.validationRuleTemplate.ruleExpressionList.find(
  //         (r) => r.codeValue === ruleKey
  //       );
  //       if (!rule) return; // Safety check

  //       const selectedPlanIds = this.plansByRule[ruleKey].targetPlans.map(
  //         (plan) => plan.id
  //       );

  //       if (selectedPlanIds.length > 0) {
  //         validationRules.push({
  //           checkinPlanId: selectedPlanIds.join(","), // Convert to comma-separated string
  //           ruleAppliesTo: ruleAppliesTo, // Or dynamic if needed
  //           rule: rule.id, // Rule ID
  //         });
  //       }
  //     });
  //     // Final payload
  //     const payload = {
  //       inputPlanId,
  //       validationRules,
  //     };
  //     await this.createValidationRule(payload);

  //     this.$refs.wizard.nextTab();
  //     this.loading = true;
  //     await this.getLocaleLanguageMethod();
  //     await this.getContentTagMethod();
  //     await this.getContentTagValueMethod();
  //     await this.getContentTypeMethod();
  //     await this.fetchTermsConditions();
  //     this.loading = false;
  //   },
  // },
  // watch: {
  //   serviceData(val) {
  //     this.availableproductsX = [];
  //     this.selectedProducts = [];
  //     if (val != null) {
  //       this.productsShow = true;
  //       this.serviceCode = val.serviceCode;
  //       for (let tempProduct of this.availableproducts) {
  //         if (this.serviceCode == tempProduct.serviceCode) {
  //           this.availableproductsX.push(tempProduct);
  //           this.selectedProducts = [];
  //         }
  //       }
  //     } else {
  //       this.productsShow = false;
  //       this.serviceCode = "";
  //     }
  //   },
  //   selectedBillFrequency: {
  //     handler(newVal) {
  //       this.plan.billfrequency = newVal.join(",");
  //     },
  //     deep: true,
  //   },
  //   selectedDurations: {
  //     handler(newVal) {
  //       this.plan.durations = newVal.join(",");
  //     },
  //     deep: true,
  //   },
  //   planTemplateData(val) {
  //     this.availableproducts = val.products;
  //     this.services = val.services;
  //   },
  //   startDate(val) {
  //     this.plan.startDate = moment(val).format("DD MMMM yyyy HH:mm:ss");
  //   },
  //   endDate(val) {
  //     this.plan.endDate = this.dateFormat(val);
  //   },
  //   isProvision(val) {
  //     this.plan.provisioingSystem = val ? "Provision" : "None";
  //   },
  // },
  async mounted() {
    // this.resetForm();
    // await this.getPlanTemplate();
    // this.getPlanAttribute();
    // this.callPriceTemplate();
    // this.getExternalPlansMethod();
    // await this.getDiscountTemplate();
    // this.allDiscounts = [...this.discountTemplate];
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.vs__selected {
  width: fit-content;
}
.multiselect__tag {
  color: rgb(48, 48, 48);
  background-color: rgba(var(--vs-primary), 0.3);
  font-size: 01rem;
}
.multiselect__tag:hover {
  background-color: rgba(var(--vs-warning), 0.3);
}
.sub-class {
  align-items: center !important;
}
.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: rgba(var(--vs-primary), 1);
  color: rgb(255, 255, 255);
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__content {
  background: rgb(255, 255, 255);
  color: #444;
  font-size: 0.9rem;
}
.multiselect__single {
  height: 0.8rem;
  font-size: 01rem;
  color: #444;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;
  margin-right: 0.625rem;
  line-height: 1;
  margin-bottom: 0.5rem;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
.margin-top {
  width: 100%;
  border-top: 1px solid #777;
  margin-top: 20px;
}
</style>
<style scoped>
.version-container {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 5px;
}
.tag {
  border: 2px solid orange;
  color: orange;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
}
.rule-card {
  height: 300px;
  min-width: 250px;
  background-color: cornsilk;
  border: 1px solid #ede4e4;
}
.header-plan {
  margin-left: 2.5rem;
  font-weight: 500;
  font-size: large;
}
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
/* ::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
} */
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
::v-deep .vs-table--not-data {
  display: none;
}
.swal2-popup {
  text-align: center;
}
.popup-width .vs-popup {
  width: 900px !important;
}
.popup-width .ql-snow .ql-tooltip {
  left: 10px !important;
}
.min-w-14vw {
  min-width: 14vw;
}
.rule-sidebar {
  margin-top: 4rem;
}
</style>
